import styled from 'styled-components';

import { baseFontFamily, baseFontSize, baseLineHeight } from 'views/services/font-scheme';
import { primaryColor } from 'views/services/color-scheme';

export const Root = styled.div`
  clear: both;
  font-family: ${baseFontFamily};
  font-size: calc(${baseFontSize} * 0.8);
  line-height: ${baseLineHeight};
  padding: 9px 15px 0 15px;
  a {
    color: ${primaryColor};
    &:hover {
      opacity: 0.75;
    }
  }
`;